import React, { Fragment } from "react";
import { Chip } from "@mui/material";
import { t } from "i18next";
import { BtmReturnRequestStatus } from "../model/btm-return-request-status";

export const BtmRequestStatusChip = ({ status }: { status: BtmReturnRequestStatus }) => {
    switch (status) {
        case BtmReturnRequestStatus.New:
            return <Chip label={t("components.blueBrandReturns.status.New")} color={"primary"} variant={"outlined"} />;
        case BtmReturnRequestStatus.Pending:
            return <Chip label={t("components.blueBrandReturns.status.Pending")} color={"warning"} variant={"outlined"} />;
        case BtmReturnRequestStatus.Processed:
            return <Chip label={t("components.blueBrandReturns.status.Processed")} color={"success"} variant={"outlined"} />;
        case BtmReturnRequestStatus.Accepted:
            return <Chip label={t("components.blueBrandReturns.status.Accepted")} color={"success"} variant={"outlined"} />;
        case BtmReturnRequestStatus.PartiallyAccepted:
            return <Chip label={t("components.blueBrandReturns.status.PartiallyAccepted")} color={"success"} variant={"outlined"} />;
        case BtmReturnRequestStatus.AutomaticallyAccepted:
            return <Chip label={t("components.blueBrandReturns.status.AutomaticallyAccepted")} color={"success"} variant={"outlined"} />;
        case BtmReturnRequestStatus.Rejected:
            return <Chip label={t("components.blueBrandReturns.status.Rejected")} color={"success"} variant={"outlined"} />;
        default:
            return <Fragment />;
    }
};
